import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http'
import { authInterceptor } from './app/interceptors/auth.interceptors'
import { unauthorizedInterceptor } from './app/services/interceptor.service'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getMessaging, provideMessaging } from '@angular/fire/messaging'
import { provideTranslateService, TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { registerIcons } from './app/icons'
import { registerLocaleData } from '@angular/common'
import localeDe from '@angular/common/locales/de';
import { BUILD_VERSION } from './environments/build-version';

registerLocaleData(localeDe);
registerIcons();

bootstrapApplication(AppComponent, {
    providers: [{
        provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        {provide: LOCALE_ID, useValue: 'de-DE'},
        provideIonicAngular(),
        provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
        provideHttpClient(withInterceptors([authInterceptor, unauthorizedInterceptor])),
        provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(), registrationStrategy: 'registerWhenStable:30000'
        }),
        provideFirebaseApp(() => initializeApp({
            apiKey: 'AIzaSyBkazghPvKd1W_uqKmnZmul-weD5_anMLc',
            authDomain: 'reforum-745f7.firebaseapp.com',
            projectId: 'reforum-745f7',
            storageBucket: 'reforum-745f7.appspot.com',
            messagingSenderId: '334837681447',
            appId: '1:334837681447:web:b64c97a9c7173f0d05ad02'
        })),
        provideMessaging(() => getMessaging()),
        provideHttpClient(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: `.json?v=${BUILD_VERSION}`
            }), defaultLanguage: 'de'
        }),
    ],
});
